<template>
    <div class="result">

        <template v-if="result.description && (result.description.indexOf('<hr />')||null)!=-1">
            <div class="title_cover mt-5">
                <h3>{{$parent.uniquesso(result.title)}}</h3>
            </div>
            
            <div class="description mt-3 mb-10" v-html="result.description.split('<hr />')[0]"></div>

            <div class="d-flex thumb-inner-images flex-column justify-space-between align-center mb-10">
                <v-img
                    contain class="rounded-lg" max-width="100%" :src="result.photo" :lazy-src="result.photo" crossOrigin="true" 
                ></v-img>
            </div>

            <v-dialog v-model="dialog"  scrollable max-width="600">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" large dark rounded v-bind="attrs" v-on="on">Lanjut</v-btn>
                </template>
                <v-card>
                    <v-card-title v-html="result.title"></v-card-title>
                    <v-card-text v-html="result.description.split('<hr />')[1]"></v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <share :data_api="data_api" :currentUrl="currentUrl" :playAgain="1" 
                            :connected="result.ic_connected" :button="result.button_label" :shareNav="true" :connected_url="urlConnect"
                        />
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <template v-else-if="multiple && index < multiple.length" >
            <v-col  v-for="(m,i) in multiple" :key="m.i">
                <div v-if="index == i " >
                    <div class="title_cover mt-5">
                        <h3>{{$parent.uniquesso(m.title)}}</h3>
                    </div>
                    <div class="description mt-3" v-html="m.description"></div>
                    <div class="d-flex thumb-inner-images flex-column justify-space-between align-center">
                        <v-img
                            contain class="rounded-lg" max-width="100%" :src="m.photo" :lazy-src="m.photo"
                        ></v-img>
                    </div>
                    <div class="text-center button_motif mt-4 mb-4">
                        <v-btn @click="index++" large rounded color="primary" dark> Lanjut </v-btn>
                    </div>
                </div>
            </v-col> 
        </template>

        <template v-else>
            <div class="title_cover mt-5">
                <h3>{{$parent.uniquesso(result.title)}}</h3>
            </div>
            <div class="description mt-3" v-html="result.description"></div>
            <div class="d-flex thumb-inner-images flex-column justify-space-between align-center">
                <v-img
                    contain class="rounded-lg" max-width="100%" :src="result.photo" :lazy-src="result.photo"
                ></v-img>
            </div>
            <share :data_api="data_api" :currentUrl="currentUrl" :playAgain="!data_api.is_unique" 
                :connected="result.ic_connected" :button="result.button_label" :shareNav="true" :connected_url="urlConnect"
                :title="result.title||null" :description="result.description||null"
            />
        </template>
        
    </div>
</template>


<script>
const Share = () => import(/* webpackChunkName: "share" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */'../Share.vue');

export default {
  name: "ResultPersonality",
  props:['data_api', 'currentUrl'],
  components: { Share },
  data() {
    return {
      dialog: false,
      result: {
          title:null,description:null,photo:null,ic_connected:null,button_label:null
      },
      multiple: null,
      index: 0,
      urlConnect: null,
      currentUrlResult: this.currentUrl,
    };
  },

  mounted()
  {
      if(Object.keys(this.$store.state.data.post.answer).length)
      {
          var answeredId = Object.keys(this.$store.state.data.post.answer);
          var answeredOption = this.$store.state.data.post.answer[answeredId] || null;
          if( this.data_api.personality.option )
          {
              for( var i in this.data_api.personality.option )
              {
                  var id = this.data_api.personality.option[i].id || null;

                  if( id && id == answeredOption )
                  {
                      var resultID = this.data_api.personality.option[i].assign_result;
                      var resultMultipleID = JSON.parse(this.data_api.personality.option[i].assign_result_multiple);
                      if( this.data_api.personality.result )
                      {
                        var multiple = [];

                          for( var j in this.data_api.personality.result )
                          {
                            if( this.data_api.personality.result[j].id == resultID )
                            {
                                this.result = this.data_api.personality.result[j];

                            }

                            if(resultMultipleID)
                            {
                                for( var k in resultMultipleID)
                                {
                                    if(this.data_api.personality.result[j].id == resultMultipleID[k]['id'] )
                                    {
                                        multiple.push(this.data_api.personality.result[j]);
                                        this.multiple = multiple;
                                    }
                                }
                            }

                          }                          
                      }

                  }
              }
          }
        
          this.urlConnect = this.$store.state.axios.baseURL + 'interactive2/'+this.result.ic_connected+'?s='+ this.result.ic_connected_question
          
      }
      else this.$router.push({name:'question'});
  }
}
</script>